import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { RdtResumen, RdtRdtsResponse } from '@/types/api';

// Listado de RDTs de una obra (GET /api/obras/:cc/rdts) — alimenta la
// columna izquierda de DetalleObra. Cada mutation de rdts.ts invalida esta
// query (['obra-rdts', cc]) además de ['rdt', id] puntual — ver
// hooks/use-rdt-mutations.ts.
export function useObraRdts(cc: string) {
  return useQuery({
    queryKey: ['obra-rdts', cc],
    queryFn: () => api<RdtRdtsResponse>(`/api/obras/${encodeURIComponent(cc)}/rdts`),
    select: (data): RdtResumen[] => data.rdts,
    enabled: cc.length > 0,
    staleTime: 30_000,
  });
}
